import { render, staticRenderFns } from "./settings-menu.svg.vue?vue&type=template&id=3a622aa2&"
import script from "./settings-menu.svg.vue?vue&type=script&lang=js&"
export * from "./settings-menu.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports